import { ApiRoutes } from '@gr/core/api-routes';
import type { ChannelDto, CreateChannelRequestDto, UpdateChannelRequestDto, WeeklySlot } from '@gr/core/distribution/channels/dto';
import type { OperationResult } from '@gr/utils/operation-result';
import type { HttpClient } from '../../../shared/http/http-client';

export class ChannelsApi {
  constructor(private readonly http: HttpClient) {}

  list(blogId: string): Promise<OperationResult<ChannelDto[]>> {
    return this.http.get(ApiRoutes.channels.list(blogId));
  }
  create(blogId: string, input: CreateChannelRequestDto): Promise<OperationResult<ChannelDto>> {
    return this.http.post(ApiRoutes.channels.list(blogId), input);
  }
  update(blogId: string, channelId: string, input: UpdateChannelRequestDto): Promise<OperationResult<ChannelDto>> {
    return this.http.patch(ApiRoutes.channels.byId(blogId, channelId), input);
  }
  setSlots(blogId: string, channelId: string, slots: WeeklySlot[]): Promise<OperationResult<ChannelDto>> {
    return this.http.put(ApiRoutes.channels.slots(blogId, channelId), { slots });
  }
  delete(blogId: string, channelId: string): Promise<OperationResult<null>> {
    return this.http.delete(ApiRoutes.channels.byId(blogId, channelId));
  }
}
